import moment from "moment";

/**
 * Formats the given date to display various based upon currrent date
 * @param dateValue The value to format for correct date display
 * @param ifEmptyOrInvalidDate The string to display if the passed in dateValue is not a valid date string (default is '-')
 * @param nowOverride Only used for testing - if you want to override the default moment.now() value
 * @returns formatted date string
 */
export const getDateDisplay = (
	dateValue: string,
	ifEmptyOrInvalidDate = "-",
	nowOverride?: () => moment.Moment
) => {
	const now = nowOverride ? nowOverride() : moment();
	const dateToFormat = moment(dateValue);

	if (!dateToFormat.isValid()) {
		return ifEmptyOrInvalidDate;
	}

	// same day
	if (dateToFormat.isSame(now, "day")) {
		return dateToFormat.format("h:mm A");
	}

	// within past 7 days
	if (dateToFormat.isAfter(now.clone().subtract(7, "days"))) {
		return dateToFormat.format("ddd h:mm A");
	}

	// same year, show day/month without year
	if (dateToFormat.isSame(now, "year")) {
		return dateToFormat.format("ddd DD MMM H:mm");
	}

	// otherwise, full date
	return dateToFormat.format("DD/MM/YYYY");
};
